import request from "@/utils/request";
import store from "@/store";

export function getCompanyInformation(params) {
  return request({
    url: "/company/company_information/get_default/",
    method: "get",
    params,
  });
}

export function getNavigation(params) {
  return request({
    url: "/company/company_information/get_nav_info/",
    method: "get",
    params,
  });
}

export function getBannerList(params) {
  return request({
    url: "/company/common_banners/",
    method: "get",
    params,
  });
}

export function getFAQInformation(params) {
  return request({
    url: "/company/question_information/get_default/",
    method: "get",
    params,
  });
}

export function getFAQList(params) {
  return request({
    url: "/company/question_categories/",
    method: "get",
    params,
  });
}

export function getFAQDetail(id, params) {
  return request({
    url: "/company/questions/" + id + "/",
    method: "get",
    params,
  });
}

export function setFAQLogsWithUser(data) {
  return request({
    url: "/company/question_logs/",
    method: "post",
    headers: { Authorization: "JWT " + store.state.user.accessToken },
    data,
  });
}

export function setFAQLogs(data) {
  return request({
    url: "/company/question_logs/",
    method: "post",
    data,
  });
}
